// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var InvoiceBuilderController = function ($scope, $routeParams, $http, $location, $timeout, gettextCatalog, gettext,
    ProductInfo, Contract, BillingSettings) {
    $scope.isSendInvoice = false;
    $scope.deliveryPeriodStart = null
    $scope.deliveryPeriodEnd = null;
    
    var versionCounter = 0;
    let nowMoment = moment();
    $scope.billingDate = moment(nowMoment).toDate();
    $scope.billingMaxDate = moment(nowMoment).toDate();
    $scope.billingMinDate = moment(nowMoment).subtract(3, 'months').toDate();

    // load global settings
    $scope.billingSettings = BillingSettings.get({}, function () {
        $scope.isSendInvoice = $scope.billingSettings.SendInvoiceAutomatically;
    });

    $scope.addLine = function () {
        var line = { Quantity: 1 };
        if ($scope.lines.length > 0)
            line.TaxPolicyId = $scope.lines[$scope.lines.length - 1].TaxPolicyId;
        else
            line.TaxPolicyId = $scope.productInfo.getDefaultTaxPolicyId();

        $scope.lines.push(line);
        $scope.items.push();
        $scope.fetchInvoiceDelayed();
    };

    $scope.removeLine = function (index) {
        $scope.lines.remove(index);
        $scope.items.remove(index);
        $scope.fetchInvoiceDelayed();
    };

    $scope.isInvoice = function () {
        return $scope.sign > 0;
    };

    function getItemListIndex(index)
    {
        for (let i = index; i >= 0; i--) {
            if ($scope.lines[i].TaxPolicyId == null) {
                index--;
            }
        }
        return index;
    }

    function getLineItem (index) {
        if ($scope.lines[index].TaxPolicyId == null)
            return undefined;

        return $scope.invoice.ItemList[getItemListIndex(index)];
    }

    function getDTO() {
        let dto = { ItemList: [] };
        dto.isInvoice = $scope.isInvoice();
        dto.Prologue = $scope.prologue;
        dto.Epilogue = $scope.epilogue;
        dto.BillingDate = $scope.billingDate;

        for (let i = 0; i < $scope.lines.length; i++) {
            if ($scope.lines[i].TaxPolicyId != null) {
                let dtoLine = angular.copy($scope.lines[i]);
                dtoLine.Quantity *= $scope.sign;

                dto.DeliveryPeriodStart = $scope.deliveryPeriodStart;
                dto.DeliveryPeriodEnd = $scope.deliveryPeriodEnd;
                dto.ItemList.push(dtoLine);
            }
        }
        return dto;
    }

    $scope.save = function () {
        if ($scope.sent) return;
        $scope.sent = true;

        let dto = getDTO();

        $http({
            method: "POST",
            url: "/api/v1/contracts/" + $routeParams.contractId + "/invoiceBuilder",
            data: dto,
            cache: false
        }).then(function (response) {
            $location.path(($scope.isSendInvoice ? "/invoices/" : "/invoice-drafts/") + response.data.Id);
            if (response.data.Multiple) {
                let title = gettextCatalog.getString(gettext($scope.isInvoice() ? "Invoice Builder" : "CreditNote Builder"))
                let message = gettextCatalog.getString(gettext($scope.isSendInvoice ? "Produced more than one invoice!" : "Produced more than one draft invoice!"))
                let additionalMessage = gettextCatalog.getString(gettext("Please check Contract Ledger!"));
                $scope.onlyOk(title, message + ' ' + additionalMessage);
            }
        }, function () {
            $scope.sent = false;
        });
    };

    function fetch() {
        let requestedVersionCounter = versionCounter;
        $scope.current = false;

        let invoiceReceived = function (response) {
            let invoice = response.data;
            if (requestedVersionCounter === versionCounter) {
                $scope.invoice = invoice;
                for (let i = 0; i < $scope.lines.length; i++)
                    $scope.items[i] = getLineItem(i);
                $scope.current = true;
                if (typeof $scope.prologue !== 'string')
                    $scope.prologue = invoice.Prologue;
                if (typeof $scope.epilogue !== 'string')
                    $scope.epilogue = invoice.Epilogue;
            }
        };

        $http({
            method: "POST",
            url: "/api/v1/contracts/" + $routeParams.contractId + "/invoiceBuilderPreview",
            data: getDTO(),
            cache: false
        }).then(invoiceReceived);
    }

    $scope.fetchInvoiceDelayed = function () {
        if ($scope.deliveryPeriodStart > $scope.deliveryPeriodEnd)
            
        
        versionCounter++;
        if ($scope.timer)
            $timeout.cancel($scope.timer);
        $scope.timer = $timeout(function () {
            fetch();
        }, 500);
    };

    function stringEndsWith(str, suffix) {
        return str.indexOf(suffix, str.length - suffix.length) !== -1;
    }

    if (stringEndsWith($location.path(), "/build-invoice")) {
        $scope.sign = +1;
    } else if (stringEndsWith($location.path(), "/build-creditnote")) {
        $scope.sign = -1;
    } else {
        throw Error("Unsupported location");
    }


    $scope.sent = false;
    $scope.lines = [];
    $scope.items = [];
    fetch();
    $scope.contract = Contract.get({ contractId: $routeParams.contractId });
    $scope.productInfo = ProductInfo.get(function () {
        $scope.addLine();
        $scope.$watch('lines', $scope.fetchInvoiceDelayed, true);
        $scope.$watch('deliveryPeriodStart', $scope.fetchInvoiceDelayed, true);
        $scope.$watch('deliveryPeriodEnd', $scope.fetchInvoiceDelayed, true);
    }, false);
};
InvoiceBuilderController.$inject = ['$scope', '$routeParams', '$http', '$location', '$timeout', 'gettextCatalog',
    'gettext', 'ProductInfo', 'Contract', 'BillingSettings'];
